import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import bgImage from "../assets/all/pc_bg_move.gif";
import defaultImage from "../assets/all/pc_bg.jpg";

const globalStyles = createGlobalStyle`
${reset};
::-webkit-scrollbar{
 display:none;
}
input, button { 
    border:none; 
    } 
a{
    text-decoration:none;
    color:inherit;
    
}
*{
    box-sizing:border-box;

}
body{
    background-image:url(${bgImage});
    overflow:hidden;
    font-family:'Noto Sans KR';
    font-size:12px;
    color:#00EE13;
    
}
amplify-authenticator{
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 2;
}
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

:root{
--amplify-primary-color:#00EE13;
--amplify-primary-contrast: black;
--amplify-primary-tint:purple;
--amplify-primary-shade:#00EE13;

--amplify-secondary-color: #00EE13;
--amplify-secondary-contrast: black;
--amplify-secondary-tint: black;

--amplify-background-color:transparent;
--amplify-white:#ffff;
--amplify-smoke-white:blue;
--amplify-red: #00EE13;
--width: 1000px;
--min-width: 150px;
}

`;

export default globalStyles;
